import Vue from 'vue'
import Vuex from 'vuex'

import utilities from '../utilities';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        receiptData: {
            donorType: '',
            donorNumber: '',
            donorFullName: '',
            billingFullName: '',
            creditCardNumberMasked: '',
            creditCardAmount: '',
            creditCardType: '',
            emailAddress: '',
            showEmailMessage: false,
            creditCardTransactionID: '',
            creditCardTransactionDate: '',
            creditCardTransactionStatus: '',
            creditCardReferenceNumber: '',
        },

        initialDonationData: {
            donorType: '',
            donorNumber: '',
            amount: 0.0,
            zipCode: '',
            locationCode: '',
            firstName: '',
            lastName: '',
            fullName: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
        },
        token: '',

        errorMessages: [],
    },

    mutations: {
        setReceiptData(state, receiptPayload) {
            state.receiptData.donorType = receiptPayload.donorType;
            state.receiptData.donorNumber = receiptPayload.donorNumber;
            state.receiptData.donorFullName = receiptPayload.donorFullName;
            state.receiptData.billingFullName = receiptPayload.billingFullName;
            state.receiptData.creditCardNumberMasked = receiptPayload.creditCardNumberMasked;
            state.receiptData.creditCardAmount = receiptPayload.creditCardAmount;
            state.receiptData.creditCardType = receiptPayload.creditCardType;
            state.receiptData.emailAddress = receiptPayload.emailAddress;
            state.receiptData.showEmailMessage = receiptPayload.showEmailMessage;
            state.receiptData.creditCardTransactionID = receiptPayload.creditCardTransactionID;
            state.receiptData.creditCardTransactionDate = receiptPayload.creditCardTransactionDate;
            state.receiptData.creditCardTransactionStatus = receiptPayload.creditCardTransactionStatus;
            state.receiptData.creditCardReferenceNumber = receiptPayload.creditCardReferenceNumber;
        },

        clearReceiptData(state) {
            state.receiptData.donorType = '';
            state.receiptData.donorNumber = '';
            state.receiptData.donorFullName = '';
            state.receiptData.billingFullName = '';
            state.receiptData.creditCardNumberMasked = '';
            state.receiptData.creditCardTransactionDate = '';
            state.receiptData.creditCardAmount = 0.0;
            state.receiptData.creditCardType = '';
            state.receiptData.emailAddress = '';
            state.receiptData.showEmailMessage = false;
            state.receiptData.creditCardTransactionID = '';
            state.receiptData.creditCardTransactionStatus = '';
            state.receiptData.creditCardReferenceNumber = '';
        },

        setInitialData(state, initDataPayload) {
            state.initialDonationData.donorType = initDataPayload.donorType;
            if (initDataPayload.donorNumber) {
                state.initialDonationData.donorNumber = initDataPayload.donorNumber.toUpperCase();
            }
            if (initDataPayload.donorName) {
                state.initialDonationData.fullName = initDataPayload.donorName;
            }
            state.initialDonationData.amount = initDataPayload.amount;
            state.initialDonationData.zipCode = utilities.stripZipPlusFour(initDataPayload.zipCode).toUpperCase();
            state.initialDonationData.locationCode = initDataPayload.locationCode || '';
        },

        setAdditionalData(state, resultPayload) {
            // Note the payload here comes from the server and uses PascalCasing, not camelCasing
            state.initialDonationData.firstName = resultPayload.FirstName;
            state.initialDonationData.lastName = resultPayload.LastName;
            state.initialDonationData.fullName = `${resultPayload.FirstName} ${resultPayload.LastName}`;
            state.initialDonationData.address1 = resultPayload.Address1;
            state.initialDonationData.address2 = resultPayload.Address2;
            state.initialDonationData.city = resultPayload.City;
            state.initialDonationData.state = resultPayload.State;
        },

        clearInitialData(state) {
            state.initialDonationData.donorType = '';
            state.initialDonationData.donorNumber = '';
            state.initialDonationData.amount = 0.0;
            state.initialDonationData.zipCode = '';
            state.initialDonationData.locationCode = '';
            state.initialDonationData.firstName = '';
            state.initialDonationData.lastName = '';
            state.initialDonationData.fullName = '';
            state.initialDonationData.address1 = '';
            state.initialDonationData.address2 = '';
            state.initialDonationData.city = '';
            state.initialDonationData.state = '';
        },

        addErrorMessage(state, errorMessage) {
            state.errorMessages.push(errorMessage);
        },

        clearErrorMessages(state) {
            state.errorMessages = [];   // clears the errorMessages array
        },
        setPaymentToken(state, value) {
          if (value == null) {
            return;
          }
            state.token = value;
        },
    },

    getters: {
        anyErrors: state => state.errorMessages.length !== 0,
        errorsCount: state => state.errorMessages.length,
    },
})
